import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {createStyles, Theme as AugmentedTheme, FormControl, Grid, InputLabel} from '@material-ui/core';
import RenderAttachment from '../../Attachment';
import { randomID } from '@tuqqi/common';
interface IFile {
    policy: string,
    signature: string,
    fileFieldActions: FileFieldActions
    sourceField: string
    required: boolean
    fieldName: string
    isRtl: boolean
}

export type FileFieldActions = {
    addFiles: (sourceField: string, fileData: any[]) => void;
    getFileFieldKeys: (sourceField: string) => string[];
    removeFile: (sourceField: string, fileDataKey: string) => void;
    attachments: any[];
}


const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    //@ts-ignore
    inputLabel: theme.inputLabel,
    //@ts-ignore
    requiredLabel: theme.requiredLabel,
    //@ts-ignore
    formControl: theme.formControl
}))


export default function FileField({ signature, policy, fieldName, fileFieldActions, sourceField, isRtl, required }: IFile) {
    const classes = useStyles();
    const [id] = useState(`${randomID()}_file_id`)

    const getUploadFiles = (fileData: any) => {
        fileFieldActions.addFiles(sourceField, fileData)
    }
    const removeUploadFile = (fileDataKey: string) => {
        fileFieldActions.removeFile(sourceField, fileDataKey)
    }
    const keys = fileFieldActions.getFileFieldKeys(sourceField)
    const attachmentsField = (fileFieldActions.attachments ?? [])
        .filter(x => keys.includes(x.key))
    
    const isEmpty = !attachmentsField || attachmentsField.length === 0
    const showRequired = required && isEmpty
        
    return(
        <>
            <InputLabel
            style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
        }} 
            htmlFor={sourceField} 
            className={showRequired ? classes.requiredLabel : classes.inputLabel}
        >{fieldName}</InputLabel>
            <FormControl className={classes.formControl}>
                <Grid container alignItems="center" direction="row" wrap="nowrap">
                    <RenderAttachment showRequired={showRequired} required={required} id={id} attachments={attachmentsField} signature={signature} policy={policy} getUploadFiles={getUploadFiles} removeUploadFile={removeUploadFile}/>
                </Grid>
            </FormControl>
            </>
    )
}